import React from "react";
import { useStateContext } from "../contexts/ContextProvider";

const ChoresCard = (props) => {
  const { chores, setCurrentChoreId } = props;
  const { handleModal } = useStateContext();

  console.log(chores);
  return (
    <div className="flex justify-center pt-2 px-5 h-3/6">
      <div className="w-full md:max-w-[500px] border-gray-300 border-1 rounded-2xl overflow-clip">
        <div className="grid grid-cols-4 h-10 w-full bg-gray-100 border-gray-300 border-b-1 py-2">
          <div className="col-span-2 pl-2">Chore Name</div>
          <div className="text-left">Frequency</div>
          <div className="text-right pr-2">Rotation</div>
        </div>
        {chores.length > 0 && (
          <div>
            <ul className="overflow-hidden overflow-y-auto pb-8">
              {chores.map((item, index) => {
                return (
                  <li
                    key={item.id}
                    className="grid grid-cols-4 items-center border-gray-300 border-2
                   hover:border-snappily-orange rounded-xl m-0.5 py-2 my-1 capitalize"
                    onClick={() => {
                      setCurrentChoreId(item.id);
                      handleModal("editChore");
                    }}
                  >
                    <div
                      className="col-span-2 text-left text-blue-500 hover:text-blue-700 pl-1 truncate 
                    text-ellipsis"
                    >
                      {item.choreName}
                    </div>
                    <div className="text-left">{item.frequency}</div>
                    <div className="text-right pr-1">
                      {item.leaseIds.length}
                      {item.leaseIds.length > 1 ? " Rooms" : " Room"}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        {chores.length === 0 && (
          <ul className="flex items-center h-52">
            <div className="flex justify-center w-full text-gray-400">
              No chores have been added yet.
            </div>
          </ul>
        )}
      </div>
    </div>
  );
};

export default ChoresCard;
